import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'

import { InputButton } from '../../Simple'
import WhatshotIcon from '@mui/icons-material/Whatshot'

export default function LegendaStatusHorario({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle align='center'>Legenda</DialogTitle>
      <DialogContent className='tw-flex tw-flex-col tw-gap-2 tw-mx-10'>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Status</TableCell>
                <TableCell>Descrição</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <Chip clickable label='Livre' color='default' variant='outlined' />
                </TableCell>
                <TableCell>Horário livre para você agendar</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Chip clickable label='Solicitei' color='primary' variant='outlined' />
                </TableCell>
                <TableCell>Horário solicitado por você, esperando confirmação</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Chip clickable label='Agendei' color='success' variant='outlined' />
                </TableCell>
                <TableCell>Horário agendado e confirmado para você</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Chip clickable label='Realizei' color='info' variant='outlined' />
                </TableCell>
                <TableCell>Horário que você agendou e compareceu</TableCell>
              </TableRow>
              <TableRow>
                <TableCell align='center'>
                  <WhatshotIcon color='gold' fontSize='small' />
                </TableCell>
                <TableCell>Horário nobre, com valor diferenciado</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', marginBottom: 2 }}>
        <InputButton onClick={onClose} color='primary' variant='contained' width={200}>
          Entendi
        </InputButton>
      </DialogActions>
    </Dialog>
  )
}
